import styled from "styled-components";

export const Img = styled.img`
  display: block;
  width: 100%;
  max-width: ${(props) => props.width || "450px"};
  margin: ${(props) => (props.center ? "0 auto" : null)};
  margin-bottom: 4.125rem;
`;
